import {
  useCallback,
  useEffect,
  useState,
} from "react";
import { toast } from "react-toastify";

import {
  getAllResults,
} from "../../../../services/acteureventServices";

import {
  getAllEvents,
} from "../../../../services/eventServices";

import {
  enrichEventsWithConvocationCounts,
  extractCollection,
} from "../utils/convocationsAdmin.utils";

export default function useConvocationsData() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const refreshEvents = useCallback(async () => {
    try {
      setLoading(true);

      const [
        eventsPayload,
        resultsPayload,
      ] = await Promise.all([
        getAllEvents(),
        getAllResults(),
      ]);

      const eventRows = extractCollection(
        eventsPayload,
        ["events"],
      );

      const resultRows = extractCollection(
        resultsPayload,
        [
          "results",
          "acteurEvents",
        ],
      );

      const enrichedEvents =
        enrichEventsWithConvocationCounts(
          eventRows,
          resultRows,
        );

      setEvents(enrichedEvents);
    } catch (error) {
      console.error(
        "Erreur lors du chargement des convocations :",
        error,
      );

      setEvents([]);

      toast.error(
        "Impossible de charger les événements et convocations.",
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshEvents();
  }, [refreshEvents]);

  return {
    events,
    loading,
    refreshEvents,
  };
}